module.exports = __webpack_public_path__ + "media/images/pic/teachers/monika-zachaj-5957bd651c5b1c62d3551d21fdb78356.png";